<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2026 (original work) Open Assessment Technologies SA ;
    import { Badge } from '@oat-sa-private/ui-elements';

    export let data;
</script>

<style>
    .badge-cell {
        display: inline-flex;
        white-space: nowrap;
    }

    .badge-cell :global(*) {
        margin-left: 0;
    }
</style>

{#if data?.text}
    <div class="badge-cell">
        <Badge color={data?.color || 'neutral'} text={data?.text || ''} skin="outline" />
    </div>
{:else}
    -
{/if}
